import { Component } from '@angular/core';

import { GLinkConfigService } from 'app/core/services/config.service';

@Component({
    selector   : 'error-500',
    templateUrl: './error-500.component.html',
    styleUrls  : ['./error-500.component.scss']
})
export class Error500Component
{
    /**
     * Constructor
     *
     * @param {GLinkConfigService} _glinkConfigService
     */
    constructor(
        private _glinkConfigService: GLinkConfigService
    )
    {
        // Configure the layout
        this._glinkConfigService.config = {
            layout: {
                navbar : {
                    hidden: true
                },
                toolbar: {
                    hidden: true
                },
                footer : {
                    hidden: true
                }
            }
        };
    }
}
